import { useQuery } from '@tanstack/react-query';
import { fetchPublicPage } from '../api/pages.public.api';
import { publicPagesKeys } from './public-pages.keys';

/**
 * A public marketing page and its visible sections, in order (MYN-197,
 * MYN-198). `staleTime` matches the backend's own `Cache-Control: max-age=60`
 * (NFR-17) - no point refetching more eagerly than the response itself is
 * considered fresh.
 */
export function usePublicPage(slug: string) {
  return useQuery({
    queryKey: publicPagesKeys.detail(slug),
    queryFn: () => fetchPublicPage(slug),
    staleTime: 60_000,
  });
}
